
<template>
  <BaseBarTran90 :name='name' :xAxisName='xAxisName' :seriesName='seriesName' :getDataAction='getDataAction' :isShowCloseBtn='isShowCloseBtn' @SizeChange='sizeChange' @StateChange='stateChange'> </BaseBarTran90>
</template>

<script>
import {
  GetThreeStockDeptTop15
} from '@/api'
import BaseBarTran90 from '../baseBarTran90.vue'

export default ({
  components: {
    BaseBarTran90
  },
  data () {
    return {
      getDataAction: GetThreeStockDeptTop15,
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    },
    xAxisName: {
      type: String,
      default () {
        return '金额'
      }
    },
    seriesName: {
      type: String,
      default () {
        return '汇总金额'
      }
    },
  },
  //监听beforinfo值的变化
  watch: {
  },
  methods: {

    sizeChange (a, b, c, d) {
      this.$emit('SizeChange', a, b, c, d)
    },
    stateChange (a, b) {
      this.$emit('StateChange', a, b)
    },

  },//自定义指令


  mounted () {
    // this.init()
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    // this.getData();
  },
})
</script>
<style scoped lang="scss">
</style>
